import Vue from 'vue'
import Router from 'vue-router'

import layout from '@/layout'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      hidden: true
    },
    // {
    //   path: '/',
    //   component: layout,
    //   redirect: '/warden',
    //   meta: {title: '會員管理', icon: 'el-icon-s-custom'},
    //   children: [{
    //     path: '/warden',
    //     name: 'warden',
    //     component: () => import('@/views/warden/index'),
    //     meta: {title: '普通會員管理'}
    //   }, {
    //     path: 'power',
    //     name: 'power',
    //     component: () => import('@/views/warden/power'),
    //     meta: {title: 'vip會員管理'}
    //   }, {
    //     path: 'apply',
    //     name: 'apply',
    //     component: () => import('@/views/warden/apply'),
    //     meta: {title: 'vip申請列表'}
    //   }]
    // },
    // {
    //   path: '/views/store',
    //   component: layout,
    //   redirect: 'store',
    //   meta: {title: '店鋪管理', icon: 'el-icon-goods'},
    //   children: [{
    //     path: 'index',
    //     name: 'index',
    //     component: () => import('@/views/store/index'),
    //     meta: {title: '店鋪資料管理'}
    //   }, {
    //     path: 'classify',
    //     name: 'classify',
    //     component: () => import('@/views/store/classify'),
    //     meta: {title: '分類管理'}
    //   }, {
    //     path: 'commodity',
    //     name: 'commodity',
    //     component: () => import('@/views/store/commodity'),
    //     meta: {title: '商品管理'}
    //   }]
    // },

    // {
    //   path: '/',
    //   component: layout,
    //   redirect: '/home',
    //   meta: {title: 'Dashboard', icon: 'el-icon-s-home'},
    //   children: [{
    //     path: 'home',
    //     name: 'home',
    //     component: () => import('@/views/home/index'),
    //     meta: {title: 'Dashboard', icon: 'el-icon-s-home'}
    //   }]
    // },
    {
      path: '/',
      component: layout,
      redirect: '/user',
      meta: {title: 'banner管理', icon: 'el-icon-picture-outline'},
      children: [{
        path: 'user',
        name: 'user',
        component: () => import('@/views/user/index'),
        meta: {title: 'banner管理'}
      }]
    },
    {
      path: '/logo',
      component: layout,
      redirect: '/logo/index',
      meta: {title: '品牌管理', icon: 'el-icon-picture'},
      children: [{
        path: 'index',
        name: 'logo',
        component: () => import('@/views/logo/index'),
        meta: {title: '品牌管理'}
      }]
    },
    {
      path: '/show',
      component: layout,
      redirect: 'show/index',
      meta: {title: '分類管理', icon: 'el-icon-goods'},
      children: [{
        path: 'show/index',
        name: 'show',
        component: () => import('@/views/show/index'),
        meta: {title: '分類管理', icon: 'el-icon-goods'}
      }]
    },
    // {
    //   path: '/user',
    //   component: layout,
    //   redirect: 'user/index',
    //   meta: {title: 'photos管理', icon: 'el-icon-picture-outline'},
    //   children: [{
    //     path: 'index',
    //     name: 'user',
    //     component: () => import('@/views/user/index'),
    //     meta: {title: 'photos管理'}
    //   }]
    // },

    // {
    //   path: '/logo',
    //   component: layout,
    //   redirect: '/logo/index',
    //   meta: {title: 'logo管理', icon: 'el-icon-picture'},
    //   children: [{
    //     path: 'index',
    //     name: 'logo',
    //     component: () => import('@/views/logo/index'),
    //     meta: {title: 'logo管理'}
    //   }]
    // },
    // {
    //   path: '/service',
    //   component: layout,
    //   redirect: '/service/index',
    //   meta: {title: '服務管理', icon: 'el-icon-service'},
    //   children: [{
    //     path: 'index',
    //     name: 'service',
    //     component: () => import('@/views/service/index'),
    //     meta: {title: '服務管理'}
    //   }]
    // },
    // {
    //   path: '/team',
    //   component: layout,
    //   redirect: '/team/index',
    //   meta: {title: '團隊管理', icon: 'el-icon-star-on'},
    //   children: [{
    //     path: 'index',
    //     name: 'team',
    //     component: () => import('@/views/team/index'),
    //     meta: {title: '團隊管理'}
    //   }]
    // },
    {
      path: '/shop',
      component: layout,
      redirect: '/news/index',
      meta: {title: '产品管理', icon: 'el-icon-s-promotion'},
      children: [{
        path: 'index',
        name: 'news',
        component: () => import('@/views/news/index'),
        meta: {title: '產品管理'}
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js